import {
	TENTATIVE_EXPENSE_NAME,
	TENTATIVE_EXPENSE_TYPE,
} from "web_myplann/Finances/constants";
import type { FinanceState } from "web_myplann/Finances/State/FinanceAtom";

const isTentativePlaceholder = (expense: FinanceState["expenses"][number]) =>
	expense.type === TENTATIVE_EXPENSE_TYPE &&
	expense.name === TENTATIVE_EXPENSE_NAME;

export const isDetailedExpenses = (expenses: FinanceState["expenses"]) =>
	expenses.length > 1 ||
	(expenses.length === 1 && !isTentativePlaceholder(expenses[0]));
